import { Form as FormFormik } from 'formik';
import { styled } from '@mui/material';
import { Wrapper as WrapperUi } from '@ui/index';

export const Wrapper = styled(WrapperUi)`
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
`;

export const Header = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: 24,
  gap: 8,
  '& > *:first-child': {
    flex: '1 1 100%',
  },
}));

export const FormFields = styled('div')(() => ({
  padding: 24,
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
}));

export const FormField = styled('div')(() => ({
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
}));

export const TypesFieldWrap = styled('div')`
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Form = styled(FormFormik)`
  height: 100%;
  overflow: auto;
`;
